<template>
  <main class="transfer">
    <div class="col-sm-8 mx-auto">
      <h1 class="display-2">Envoi</h1><hr>
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label>Destination</label>
          <vue-tel-input @onInput="onInput" :disabledFormatting="true" :preferredCountries="['bj']"></vue-tel-input>
        </div>
        <div class="form-group">
          <label>Montant</label>
          <input type="text" class="form-control" v-model="payload.amount">
        </div>
        <div class="form-group">
          <label>Frais</label>
          <input type="text" class="form-control" :value="0*payload.amount" disabled/>
        </div>
        <div class="form-group">
          <label>Total</label>
          <input type="text" class="form-control" :value="total" disabled/>
        </div>
        <div class="form-group" v-if="$store.getters.loggedAs.type === 'Marchand'">
          <label>Equivalence</label>
          <div class="input-group">
            <input type="number" class="form-control" :value="total/rate" disabled/>
            <div class="input-group-prepend">
              <select class="custom-select mr-sm-2" v-model="rate">
                <option v-for="(value, name, index) in devi.change" v-if="name !== 'id'" :key="index" :value="value*10000">{{name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Code</label>
          <input type="password" class="form-control" v-model="payload.code" autocomplete>
        </div>
        <div class="form-group">
          <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-warning btn-lg']">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
            Valider
          </button>
        </div>
      </form>
    </div>
  </main>
</template>

<script>

export default {
  name: 'transfer',
  data() {
    return {loading: false, payload: {type: 'transfer', to: {type: "Standard"}}, rate: 0, flux: [{id: 1, key: 'XOF', value: 10},{id: 2, key: 'EUR', value: 0},{id: 3, key: 'USD', value: 0},]}
  },
    computed: {
      devi() { return this.$store.getters['resource/DEVI'] },
      total() {
        return this.payload.amount*(1 + 0);
      }
    },
  methods: {
    onInput(e) {
      if(e.isValid) this.payload.to.no = e.country.dialCode + e.number ///@param {string} number @param {Boolean} isValid @param {string} country // Ex: inputted: (AU) 0432 432 432 => number = '+61432421546'
    },
    onSubmit() { 
      this.loading = true;
      this.$store.dispatch('transact/insertTrans', this.payload).then(
        () => {
          this.payload = {type: 'transfer', to: {type: "Standard"}}; 
          this.loading = false
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">

</style>
